import { render, staticRenderFns } from "./ReportSummaryCH.vue?vue&type=template&id=7818484a"
import script from "./ReportSummaryCH.vue?vue&type=script&lang=js"
export * from "./ReportSummaryCH.vue?vue&type=script&lang=js"
import style0 from "./ReportSummaryCH.vue?vue&type=style&index=0&id=7818484a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports